import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';

import * as Actions from './returns.filtering.actions';

const initialState = {};

const actionHandlerMap = {
  [Actions.RETURNS_CHANGE_FILTERS]: (state, { statusViewId, appliedFilters }) => {
    return {
      ...state,
      [statusViewId]: {
        ...state[statusViewId],
        appliedFilters,
      },
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './returns.filtering.reducer.metadata';
